/**
 *
 * ColorPickerList
 *
 */
import React, { useEffect } from 'react';
import { Color } from 'lib/modelBuilder/entities/Color';

import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';
import ItemPicker from 'helpers/ItemPicker';
import Img from 'components/Img';

interface Props {
  items: ItemPicker[];
  onClick: any;
  onDoubleClick: any;
  onMouseOver: any;
  big?: boolean;
  medium?: boolean;
  wide?: boolean;
  selectedColor?: Color;
}

function ItemPickerList({
  items,
  onClick,
  onDoubleClick,
  onMouseOver,
  big,
  medium,
  wide,
  selectedColor,
}: Props) {
  // Rebuilt tooltip if colors change
  useEffect(() => ReactTooltip.rebuild(), [items]);

  return (
    <div className="bg-white">
      <div
        className={`flex ml-2 overflow-auto h-28 ${!big ? 'flex-wrap' : ''}`}
      >
        {items &&
          items.map(item => (
            <StyledItemButton
              key={item.name}
              onClick={() => {
                onClick(item);
              }}
              onDoubleClick={onDoubleClick}
              onMouseOver={() => {
                onMouseOver(item);
              }}
              color={
                item.color && !item.imgSrc ? item.color.hexaHtml : undefined
              }
              big={big}
              medium={medium}
              data-tip={item.name}
              data-for="nameInfo"
              selected={
                item.color && selectedColor?.reference === item.color.reference
              }
            >
              {item.imgSrc && (
                <StyledItemButtonImg
                  src={item.imgSrc as string}
                  alt={item.name as string}
                  big={big}
                  wide={wide}
                  medium={medium}
                />
              )}
            </StyledItemButton>
          ))}
      </div>
      <ReactTooltip id="nameInfo" place="bottom" type="dark" />
    </div>
  );
}

export default ItemPickerList;

const StyledItemButton = styled.button<{
  color?: string;
  medium?: boolean;
  big?: boolean;
  selected?: boolean;
}>`
  height: ${p => (p.big ? '5rem' : '3.2rem')};
  width: ${p => (p.big ? '5rem' : '3.2rem')};
  padding: 0.5rem;
  background-color: ${p => (p.color ? p.color : 'inherit')};
  border: ${p => (p.color ? 'solid 1px #e2e8f0' : 'none')};
  &:hover {
    background-color: ${p => p.theme.hover};
  }

  ${p =>
    p.selected &&
    css`
      background-color: ${p => p.theme.main} !important;
    `}

  ${p =>
    p.medium &&
    css`
      height: 3.5rem;
      width: 3.5rem;
      padding: 0.2rem;
    `}
`;

const StyledItemButtonImg = styled(Img)<{
  big?: boolean;
  medium?: boolean;
  wide?: boolean;
}>`
  height: ${p => (p.big ? '4rem' : '2rem')};
  width: ${p => (p.wide ? '6rem' : '4rem')};
  background-color: white;

  ${p =>
    p.medium &&
    css`
      height: 3rem;
      width: 3rem;
    `}
`;
